Bacon = require 'baconjs'
R = require 'ramda'
Globalize = require 'globalize'
{ loadLocale } = require 'i18n'

{ loadResourceFromUrl, findResourceLink, postResource } = require "utils/resources"

currentRestaurant = new Bacon.Bus

restaurantStream = currentRestaurant
  .flatMap loadResourceFromUrl
  .map R.prop 'restaurant'
  .toProperty()

localeIdStream = restaurantStream
  .map R.prop 'locale'
  .toProperty()

localeStream = localeIdStream
  .flatMap loadLocale
  .toProperty()

module.exports =
  restaurant: restaurantStream
  locale: localeStream
  localeId: localeIdStream
  connect: (restaurantUrlStream) -> currentRestaurant.plug(restaurantUrlStream)
